import { defineCustomElement, NectaryElement } from '../utils';
const templateHTML = '<style>:host{display:block;height:100%}#wrapper{display:flex;flex-direction:column;box-sizing:border-box;width:100%;height:100%;overflow-y:auto}</style><div id="wrapper"><slot></slot></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-list', class extends NectaryElement {
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
  }
  connectedCallback() {
    this.setAttribute('role', 'list');
  }
});